import React, { FC } from 'react';
import { StatusModel } from '../pages/Sandbox.page';

interface CurrentStateProps {
  status?: StatusModel;
}

export const CurrentState: FC<CurrentStateProps> = ({ status }) => {
  if (!status) {
    // Skeleton!
    return <div className="pure-u-1-2">
      <p>Current status: <span>{}</span></p>
      <div>
        <p>Current Task: <span/></p>
        <p>Owner: <span/></p>
        <p>Branch Name: <span/></p>
        <p>Started At: <span/></p>
      </div>
    </div>;
  }

  return <div className="pure-u-1-2">
    <p>Current status: <span>{status.currentStatus}</span></p>
    <div>
      <p>Current Task: <span>{status.currentTask?.id}</span></p>
      <p>Owner: <span>{status.currentTask?.actor}</span></p>
      <p>Branch Name: <span>{status.currentTask?.branchName}</span></p>
      <p>Started At: <span>{status.currentTask?.addedAt}</span></p>
    </div>
  </div>;
};
